import { formatDate } from '../../../ui/utils/format-date';

import { formatUsd } from './billing-format';

import type { GetBillingOverviewResponseDtoDiscountsItem } from '../../../api/generated/model/getBillingOverviewResponseDtoDiscountsItem';

export type BillingDiscount = GetBillingOverviewResponseDtoDiscountsItem;

/** "15% off" / "$50 off". */
export const discountLabel = (discount: Pick<BillingDiscount, 'percentOff' | 'amountOffCents'>): string => {
  if (discount.percentOff !== null) return `${discount.percentOff}% off`;
  if (discount.amountOffCents !== null) return `${formatUsd(discount.amountOffCents)} off`;
  return 'Discount';
};

/** "15% off · Partner 15% · until Jan 19, 2027" — the coupon's name only when it says more than the label. */
export const discountSummary = (discount: BillingDiscount): string =>
  [
    discountLabel(discount),
    discount.name && discount.name !== discountLabel(discount) ? discount.name : null,
    discount.promotionCode ? `code ${discount.promotionCode}` : null,
    discount.endsAt ? `until ${formatDate(discount.endsAt)}` : null,
  ]
    .filter(Boolean)
    .join(' · ');

/** True when the discounted amount is lower than the list price (both known). */
export const isDiscounted = (cents: number | null | undefined, discountedCents: number | null | undefined): boolean =>
  cents !== null && cents !== undefined && discountedCents !== null && discountedCents !== undefined && discountedCents < cents;

/** "$339.15" when discounted, else "$399"; for Select labels and other plain-text spots. */
export const formatDiscountedUsd = (cents: number | null | undefined, discountedCents: number | null | undefined): string =>
  isDiscounted(cents, discountedCents) ? formatUsd(discountedCents ?? null) : formatUsd(cents ?? null);
